import { Component, OnInit, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-payment-modal',
  templateUrl: './add-payment-modal.component.html',
  styles: []
})
export class AddPaymentModalComponent implements OnInit {
  @Output() result: EventEmitter<any> = new EventEmitter();
  paymentForm: FormGroup;
  submitted: boolean = false;
  invoice: any = null;

  @Input('invoice')
  set setInvoice(value: any) {
    if (value) {
      this.invoice = value;
      this.paymentForm.get('amount').setValidators([
        Validators.required,
        Validators.min(0.01),
        Validators.max(parseFloat(this.invoice.due_amount))
      ]);

      this.paymentForm.get('amount').updateValueAndValidity();
    } else {
      this.invoice = null;
    }
  }

  constructor(public activeModal: NgbActiveModal, private el: ElementRef) {
    el.nativeElement.id = 'addPayment';
    el.nativeElement.classList.add('addPayment');
  }

  ngOnInit() {
    this.paymentForm = new FormGroup({
      amount: new FormControl(null, [
        Validators.required,
        Validators.min(0.01)
      ])
    });

    if (this.invoice) {
      this.paymentForm.get('amount').setValidators([
        Validators.required,
        Validators.min(0.01),
        Validators.max(parseFloat(this.invoice.due_amount))
      ]);
      this.paymentForm.get('amount').updateValueAndValidity();
    }
  }

  submit() {
    this.submitted = true;
    if (this.paymentForm.valid) {
      this.activeModal.close(this.paymentForm.get('amount').value);
    }
  }
}